import moment from "moment-jalaali";


export function jalaaliPresentation(timeVal) {
    const tripStartTime = moment(timeVal);
    return tripStartTime.format('LLLL')
}

export function jalaaliDatePresentation(timeVal) {
    const tripStartTime = moment(timeVal);
    return tripStartTime.format('jYYYY/jM/jD')
}

export function jalaaliHourPresentation(timeVal) {
    const tripStartTime = moment(timeVal);
    return tripStartTime.format('HH:mm')
}

export function timeDurationPresentation(rideTimeSeconds) {
    const h = Math.floor(rideTimeSeconds / 3600);
    const m = Math.floor(rideTimeSeconds % 3600 / 60);
    const s = Math.floor(rideTimeSeconds % 3600 % 60);
    return h + ":" + m + ":" + s;
}

export function convertTime2Title(startTime) {
    const tripStartTime = moment(startTime);
    return tripStartTime.format('LLLL')
}